/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name pagetitle
 * @description Displays the current pages title
 */
angular.module('mercury.directives.pagetitle', [])
.directive('pagetitle', ["$rootScope", "title", function($rootScope, title) {
  return {
    restrict: 'A',
    template: '<div><span ng-bind="pagetitle"></span></div><div><span class="subheading" ng-bind="pagesubheader"></span></div>',
    link: function(scope) {
      scope.pagetitle = title.title;
      scope.pagesubheader = title.subheader;

      scope.$on('titleChange', function() {
        scope.pagetitle = title.title;
        scope.pagesubheader = title.subheader;
      });
    }
  };
}]);
